<dialog-header
  [title]="data?.icon ? '' : (data?.title ?? 'Confirm')"
  (onClose)="matDialogRef.close()"
  [canClose]="!data?.hideCloseIcon"
></dialog-header>

<div mat-dialog-content class="mat-typography">
  <div *ngIf="data?.icon" style="text-align: center; margin-bottom: 16px">
    <mat-icon
      [fontSet]="
        data.icon.filled ? 'material-icons' : 'material-icons-outlined'
      "
      style="
        font-size: 48px;
        width: 48px;
        height: 48px;
        color: var(--app-timber);
      "
    >
      {{ data.icon.web }}
    </mat-icon>
    <h2 style="margin-top: 12px; margin-bottom: 0; font-weight: 600">
      {{ data?.title ?? "Confirm" }}
    </h2>
  </div>
  <p
    class="dialog-body"
    [innerHTML]="data.body"
    [ngStyle]="{ 'text-align': data?.icon ? 'center' : 'left' }"
  ></p>

  <div
    *ngIf="data?.hasToggle"
    style="
      margin-top: 20px;
      display: flex;
      justify-content: space-between;
      align-items: center;
    "
  >
    <div class="form-field-label" style="color: black; font-weight: normal">
      {{ data.toggleLabel }}
    </div>
    <mat-slide-toggle
      [disabled]="false"
      [checked]="toggleValue"
      (change)="toggleValue = $event.checked"
    >
    </mat-slide-toggle>
  </div>
</div>

<div mat-dialog-actions align="end">
  <app-secondary-button
    *ngIf="data?.buttonOne"
    [title]="data.buttonOne"
    [disabled]="false"
    (tapped)="buttonOne()"
    style="margin-right: 10px"
  ></app-secondary-button>
  <app-primary-button
    *ngIf="data?.buttonThree"
    [title]="data.buttonThree"
    [disabled]="false"
    (tapped)="buttonThree()"
    bgColor="var(--app-timber)"
    color="white"
    style="margin-right: 10px"
  ></app-primary-button>
  <app-primary-button
    [title]="data.buttonTwo"
    [disabled]="false"
    (tapped)="buttonTwo()"
    bgColor="var(--app-timber)"
    color="white"
  ></app-primary-button>
</div>
